<template>
  <v-row>
    <v-col v-show="barcode" class="col-12" :class="textAlign">
      <canvas :id="canvasId"></canvas>
      <v-col
        v-show="barcodeMode === 'QRCode'"
        class="col-12"
        :class="textAlign"
      >
        {{ barcode }}
      </v-col>
    </v-col>

    <!-- no barcode -->
    <v-col v-show="!barcode" class="col-12" :class="textAlign">
      {{ $t('skidata.noBarcode') }}
    </v-col>
  </v-row>
</template>

<script>
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'
export default {
  name: 'PickupBarcode',

  props: {
    barcode: {
      type: [String, Number, null],
      required: false,
      default: null,
    },

    textAlign: {
      type: String,
      required: false,
      default: 'text-center',
    },

    barCodeWith: {
      type: Number,
      required: false,
      default: 1.3,
    },

    barcodeMode: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      canvasId: null,
    }
  },

  watch: {
    barcode() {
      this.generateBarcode()
    },
  },

  beforeMount() {
    let nanoid = require('nanoid')
    this.canvasId = nanoid(10)
  },

  mounted() {
    this.generateBarcode()
  },

  methods: {
    generateBarcode() {
      if (this.barcode) {
        if (this.barcodeMode === 'QRCode') {
          const canvas = document.getElementById(this.canvasId)
          QRCode.toDataURL(canvas, this.barcode, (error) => {
            if (error) {
              console.error(error)
            } else {
              // success
              canvas.style.width = '180px'
              canvas.style.height = '180px'
            }
          })
        } else {
          this.$nextTick(() => {
            JsBarcode('#' + this.canvasId, this.barcode, {
              width: this.barCodeWith,
              height: 70,
              fontSize: 20,
            })
          })
        }
      }
    },
  },
}
</script>
